"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { ArrowRight } from "lucide-react";

const ContactSection = () => {
  return (
    <section className="min-h-screen flex flex-col items-center justify-center px-6 py-16 bg-primaryColor/30 text-center mx-auto">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="text-4xl sm:text-6xl font-serif font-semibold text-[#A65D5D] mb-6 leading-tight"
      >
        Let’s Design Something Beautiful Together
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
        className="text-lg sm:text-xl text-[#6B4F4F] max-w-xl mb-10 leading-relaxed"
      >
        Whether you're planning a full home makeover or just refreshing a single room,
        we're here to bring your vision to life. Share your ideas, ask questions, or
        schedule a consultation—we’re just a click away.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
      >
        <Link
          href="/contact"
          className="inline-flex items-center gap-2 border-2 border-[#A65D5D] text-[#A65D5D] text-lg font-medium px-8 py-3 rounded transition-colors duration-300 hover:bg-[#A65D5D] hover:text-white group"
          aria-label="Start Your Project"
        >
          Start Your Project
          <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </motion.div>
    </section>
  );
};

export default ContactSection;
